// extracted by mini-css-extract-plugin
export default {"footerLinks":"c-f_er"};